
// @ts-check

import ResultsLoadingManager from "./ResultsLoadingManager";

/**
 *  @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 */

/** @type {JSResultAtom[]} */
const jsraNull = [];

const ResultsLoadingManagerWebInstance = new ResultsLoadingManager(jsraNull);


export default ResultsLoadingManagerWebInstance;
